/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Location,
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface LocationDataFrame
 */
export interface LocationDataFrame {
    /**
     * 
     * @type {number}
     * @memberof LocationDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof LocationDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof LocationDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Location>}
     * @memberof LocationDataFrame
     */
    data: Array<Location>;
}

export function LocationDataFrameFromJSON(json: any): LocationDataFrame {
    return LocationDataFrameFromJSONTyped(json, false);
}

export function LocationDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(LocationFromJSON)),
    };
}

export function LocationDataFrameToJSON(value?: LocationDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(LocationToJSON)),
    };
}


